import React from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import Modal from '../../../../../components/Modal';
import Img from '../../../../../components/Img';
import {
  WIDGET_LAYOUT_MANUAL,
  WIDGET_LAYOUT_TYPE_TEXT,
  WIDGET_TYPE_TEXT,
} from '../../../../../constants/service/app/widgetConstants';
import './WidgetLayoutManualModal.scss';

const WidgetLayoutManualModal = (props) => {
  const {
    isOpen,
    closeModal,
    prev,
    next,
    data,
    initialWidgetLayoutTypePageNum,
    widgetLayoutTypePageNum,
    changeLayoutType,
  } = props;
  const { widgetType } = data;
  const targetWidgetManual = WIDGET_LAYOUT_MANUAL[widgetType][widgetLayoutTypePageNum];

  return (
    <Modal
      title={`${WIDGET_TYPE_TEXT[widgetType]} - ${WIDGET_LAYOUT_TYPE_TEXT[widgetType][targetWidgetManual.layoutType]}`}
      isOpen={isOpen}
      width={420}
      height={600}
      overflow={'hidden'}
      isFooter={true}
      okText={initialWidgetLayoutTypePageNum === widgetLayoutTypePageNum ? '확인' : '해당 레이아웃 타입으로 변경'}
      onOk={() => changeLayoutType()}
      onClose={() => closeModal()}
    >
      <div className="widget-layout-manual-modal-wrap">
        <div className="control-manual-info">
          {widgetLayoutTypePageNum > 0 && <LeftOutlined className="prev" onClick={() => prev()} />}
          {widgetLayoutTypePageNum < WIDGET_LAYOUT_MANUAL[widgetType].length - 1 && (
            <RightOutlined className="next" onClick={() => next()} />
          )}
        </div>

        <div className="img-wrap">
          <Img src={targetWidgetManual.img} />
        </div>
      </div>
    </Modal>
  );
};

export default WidgetLayoutManualModal;
